// extracted by mini-css-extract-plugin
export var bandeauAlertContainer = "bandeau-alert-module--bandeau-alert-container--92741";
export var bandeauAlertTitle = "bandeau-alert-module--bandeau-alert-title--f3de3";
export var editButton = "bandeau-alert-module--edit-button--3ea43";
export var sectionAlert = "bandeau-alert-module--section-alert--a342e";
export var sectionAlertButton = "bandeau-alert-module--section-alert-button--81166";
export var sectionAlertContent = "bandeau-alert-module--section-alert-content--e2205";
export var sectionAlertHeader = "bandeau-alert-module--section-alert-header--1178e";
export var sectionAlertModal = "bandeau-alert-module--section-alert-modal--273fd";
export var sectionAlertTitle = "bandeau-alert-module--section-alert-title--e0f48";